module.exports = "<div class=\"ui-card padding-md\">\r\n  <div class=\"ui-item\">\r\n    <div class=\"flex\">\r\n      <div class=\"typo-display-1 margin-lg\">Configuración</div>\r\n    </div>\r\n  </div>\r\n  <!-- <p class=\"margin-xs\">Seleccione un proyecto</p> -->\r\n</div>\r\n<viaticos-configuracion-proyectos></viaticos-configuracion-proyectos>";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/configuracion/template.html
// module id = 3152
// module chunks = 0